// reduxjs toolkit
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BaseUrl from "../../service/API/base_url";
import { handleSuccess, handleError } from "../../utils/toast";

const handleApiResponse = (response, thunkAPI, successMessage) => {
  if (response.status === 200 || response.status === 201) {
    if (successMessage) handleSuccess(successMessage);
    return response.data;
  } else {
    handleError(response.message);
    return thunkAPI.rejectWithValue(response.data);
  }
};

const handleApiError = (error, thunkAPI, errorMessage) => {
  handleError(error.response?.data?.message || errorMessage);
  return thunkAPI.rejectWithValue(error.response?.data);
};

// List all internships
export const viewInternship = createAsyncThunk(
  "internships",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(`${BaseUrl}born-to-win-api/internships`);
      return handleApiResponse(response, thunkAPI);
    } catch (e) {
      return handleApiError(e, thunkAPI, "loading...");
    }
  }
);

// List only approved internships
export const approvedInternshipList = createAsyncThunk(
  "internships",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BaseUrl}born-to-win-api/paginate-internship`
      );
      return handleApiResponse(response, thunkAPI);
    } catch (e) {
      return handleApiError(e, thunkAPI, "loading...");
    }
  }
);

// Add new Internship
export const newInternship = createAsyncThunk(
  "internships",
  async (internshipData, thunkAPI) => {
    try {
      const response = await axios.post(
        `${BaseUrl}born-to-win-api/internships`,
        internshipData
      );
      // console.log("response : ", response);
      return handleApiResponse(response, thunkAPI, "Register successful!");
    } catch (e) {
      return handleApiError(e, thunkAPI);
    }
  }
);

// Search Internship by ID
export const singleInternship = createAsyncThunk(
  "internships",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BaseUrl}born-to-win-api/internships/${id}`
      );
      return handleApiResponse(response, thunkAPI);
    } catch (e) {
      return handleApiError(e, thunkAPI, "search Internship ...");
    }
  }
);

// Update Internship
export const updateInternship = createAsyncThunk(
  "internships",
  async ({ id, formData }, thunkAPI) => {
    try {
      const response = await axios.put(
        `${BaseUrl}born-to-win-api/internships/${id}`,
        formData
      );
      return handleApiResponse(response, thunkAPI, "Change saved successfully");
    } catch (e) {
      return handleApiError(e, thunkAPI);
    }
  }
);

// Delete Internship
export const deleteInternship = createAsyncThunk(
  "internships",
  async (id, thunkAPI) => {
    const token = JSON.parse(localStorage.getItem("userInfo")) || null;
    try {
      const response = await axios.delete(
        `${BaseUrl}born-to-win-api/internships/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return handleApiResponse(response, thunkAPI, "Delete successful!");
    } catch (e) {
      return handleApiError(e, thunkAPI);
    }
  }
);

// Single User internships
export const singleUserInternship = createAsyncThunk(
  "internships",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BaseUrl}born-to-win-api/users-internship/${id}`
      );
      return handleApiResponse(response, thunkAPI);
    } catch (e) {
      return handleApiError(e, thunkAPI, "search Internship history...");
    }
  }
);

// Approve Internship
export const approveInternship = createAsyncThunk(
  "internships",
  async (internshipData, thunkAPI) => {
    const token = JSON.parse(localStorage.getItem("userInfo")) || null;
    try {
      const response = await axios.put(
        `${BaseUrl}born-to-win-api/internship-approve/${internshipData.id}`,
        internshipData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return handleApiResponse(response, thunkAPI, "Approved successfully!");
    } catch (e) {
      return handleApiError(
        e,
        thunkAPI,
        "Please try again. Invalid credentials"
      );
    }
  }
);
